module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp23_3016.177eaac4.png";